import styled from 'styled-components';

import { Textarea } from '@dreryk/react-components';

import { medicalDevicesTranslationKeys } from '../../translations';
import { MedicalDeviceOrderFormRegister } from '../medicalDeviceOrder.types';

type AdditionalInformationFieldProps = {
   readonly register: MedicalDeviceOrderFormRegister;
};

const StyledAdditionalInformationField = styled.div`
   height: 100px;
`;
StyledAdditionalInformationField.displayName = 'StyledAdditionalInformationField';

const ADDITIONAL_INFORMATION_MAX_LENGTH = 1000;

export const AdditionalInformationField = (props: AdditionalInformationFieldProps): JSX.Element => {
   return (
      <StyledAdditionalInformationField>
         <Textarea
            testId={'additionalInformation'}
            controller={props.register('additionalInformation')}
            label={medicalDevicesTranslationKeys.fields.additionalInformation}
            placeholder={medicalDevicesTranslationKeys.fields.fillAdditionalInformation}
            maxLength={ADDITIONAL_INFORMATION_MAX_LENGTH}
            fillParent
         />
      </StyledAdditionalInformationField>
   );
};
